<template>
  <div style="height: 100%;">
    <div v-if="identity == 'student'" style="height: 100%;">
      <!-- 学生栏 -->
      <el-menu
        default-active="0"
        :default-openeds="[]"
        class="el-menu-vertical-demo"
        background-color="#333" 
        text-color="#fff"
        active-text-color="#ffd04b"
        :collapse-transition="true"
      >
        <el-menu-item index="0" @click="setPage('home')" class="no-arrow" title="返回首页">
          <template #title>
            <i class="el-icon-s-home"></i>
            <span>首页</span>
          </template>
        </el-menu-item>

       
        <!-- 课程表 -->
        <el-menu-item index ='1' @click="setPage('courses')" title="查看课程信息">
          <template #title>
            <i class="el-icon-s-platform"></i>
            <span>我的课程</span>
          </template>
        </el-menu-item>

        <el-menu-item index ='6' @click="setPage('mycredit')" title="查看我的学分">
          <template #title>
            <i class="el-icon-s-platform"></i>
            <span>我的学分</span>
          </template>
        </el-menu-item> 

          <el-submenu index="5"  class="no-arrow" title="查看个人作品">
                    <template #title>
                      <i class="el-icon-folder"></i>
                      <span>我的作品</span>
                    </template>
                    
                    <!-- 第一学期子菜单 -->
                    <el-menu-item 
                      index="5-1" 
                      @click="handleXueQiClick('第1学期')"
                      title="第1学期作品"
                      class="term-submenu"
                    >
                      第1学期
                    </el-menu-item>
                    
                    <!-- 第二学期子菜单 -->
                    <el-menu-item 
                      index="5-2" 
                      @click="handleXueQiClick('第2学期')"
                      title="第2学期作品"
                      class="term-submenu"
                    >
                      第2学期
                    </el-menu-item>
                    
                    <!-- 第三学期子菜单 -->
                    <el-menu-item 
                      index="5-3" 
                      @click="handleXueQiClick('第3学期')"
                      title="第3学期作品"
                      class="term-submenu"
                    >
                      第3学期
                    </el-menu-item>
                    
                    <!-- 第四学期子菜单 -->
                    <el-menu-item 
                      index="5-4" 
                      @click="handleXueQiClick('第4学期')"
                      title="第4学期作品"
                      class="term-submenu"
                    >
                      第4学期
                    </el-menu-item>
                  </el-submenu>

 <el-menu-item index ='3' @click="changeDialogFormVisible(true), setPage('upload')">
          <template #title>
            <i class="el-icon-upload"></i>
            <span>上传作品</span>
          </template>
        </el-menu-item>
        <el-menu-item index ='2' @click="setPage('works'),changWorksStatus(null)">
          <template #title>
            <i class="el-icon-setting"></i>
            <span>作品管理</span>
          </template>
        </el-menu-item>

       

       

              
      </el-menu>
    </div>

    <!-- 教师栏 -->
    <div v-else-if="identity == 'teacher'" style="height: 100%;">
      <el-menu
        default-active="0"
        :default-openeds="[]"
        class="el-menu-vertical-demo"
        background-color="#333" 
        text-color="#fff" 
        active-text-color="#ffd04b"
        :collapse-transition="true"
      >
        <el-menu-item index="0" @click="setPage('home')" class="no-arrow" title="返回首页">
          <template #title>
            <i class="el-icon-s-home"></i>
            <span>首页</span>
          </template>
        </el-menu-item>

        <el-submenu index="1" title="关于学生的相关操作">
          <template #title>
            <i class="el-icon-location"></i>
            <span>学生作品管理</span>
          </template>
          <el-menu-item-group>
            <!-- <el-menu-item index="1-1" @click="setPage('inform')" title="查看学生信息">
              <i class="el-icon-user"></i>
              <span>学生信息</span>
            </el-menu-item> -->
            <el-menu-item index="1-2" @click="changWorksStatus(null),setPage('works')" title="查看学生作品" style="padding-left: 40px !important;">
              <i class="el-icon-folder"></i>
              <span>作品管理</span>
            </el-menu-item>
            <!-- <el-menu-item index="1-3" @click="changeDialogFormVisible(true), setPage('upload')" title="上传新作品" style="padding-left: 40px !important;">
              <i class="el-icon-upload"></i>
              <span>上传作品</span>
            </el-menu-item> -->
            <!-- <el-menu-item index="1-4" @click="changWorksStatus(0), setPage('works')" title="查看待审核学生作品">
              <i class="el-icon-time"></i>
              <span>待审核中</span>
            </el-menu-item>
            <el-menu-item index="1-5" @click="changWorksStatus(1), setPage('works')" title="查看审核通过学生作品">
              <i class="el-icon-success"></i>
              <span>审核通过</span>
            </el-menu-item>
            <el-menu-item index="1-6" @click="changWorksStatus(2), setPage('works')" title="查看审核失败学生作品">
              <i class="el-icon-error"></i>
              <span>审核失败</span>
            </el-menu-item> -->
            
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="4" title="学生学分管理">
          <template #title>
            <i class="el-icon-folder"></i>
            <span>学生学分管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="4-1" @click="setPage('studentcredit')" title="查看学生学分信息" style="padding-left: 40px !important;">
              <i class="el-icon-notebook-2"></i>
              <span>查看学生学分</span>
            </el-menu-item>
            <el-menu-item index="4-2" @click="setPage('creditlog')" title="查看学生学分记录信息" style="padding-left: 40px !important;">
              <i class="el-icon-notebook-2"></i>
              <span>学分记录明细</span>
            </el-menu-item>
            <el-menu-item index="4-3" @click="setPage('creditrules')" title="查看学校规则信息" style="padding-left: 40px !important;">
              <i class="el-icon-notebook-2"></i>
              <span>学校规则</span>
            </el-menu-item>
            
             
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>

    <!-- 管理员栏 -->
    <div v-else-if="identity == 'admin'" style="height: 100%;background-color: #333;">
      <el-menu
        default-active="0"
        :default-openeds="[]"
        class="el-menu-vertical-demo"
        background-color="#333" 
        text-color="#fff" 
        active-text-color="#ffd04b"
        :collapse-transition="true"
      >
        <el-menu-item index="0" @click="setPage('home')" class="no-arrow" title="返回首页">
          <template #title>
            <i class="el-icon-s-home"></i>
            <span>首页</span>
          </template>
        </el-menu-item>

       <el-submenu index="1" title="专业管理">
          <template #title>
            <i class="el-icon-folder"></i>
            <span>专业管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="1-1" @click="setPage('majors')" title="查看专业信息" style="padding-left: 40px !important;">
              <i class="el-icon-notebook-2"></i>
              <span>专业管理</span>
            </el-menu-item>
            <el-menu-item index="1-4" @click="setPage('stageconfig')" title="查看阶段信息" style="padding-left: 40px !important;">
              <i class="el-icon-notebook-2"></i>
              <span>阶段管理</span>
            </el-menu-item>
            <el-menu-item index="1-2" @click="setPage('classe')" title="查看班级信息" style="padding-left: 40px !important;">
              <i class="el-icon-notebook-2"></i>
              <span>班级管理</span>
            </el-menu-item>
            <el-menu-item index="1-3" @click="setPage('courses')" title="查看课程信息" style="padding-left: 40px !important;">
              <i class="el-icon-notebook-1"></i>
              <span>课程管理</span>
            </el-menu-item>
             
          </el-menu-item-group>
        </el-submenu>

        <!-- 学分管理 -->

         <el-submenu index="4" title="学分管理">
          <template #title>
            <i class="el-icon-folder"></i>
            <span>学分管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="4-1" @click="setPage('studentcredit')" title="查看学生学分信息" style="padding-left: 40px !important;">
              <i class="el-icon-notebook-2"></i>
              <span>学分管理</span>
            </el-menu-item>
            <el-menu-item index="4-2" @click="setPage('creditlog')" title="查看学生学分记录信息" style="padding-left: 40px !important;">
              <i class="el-icon-notebook-2"></i>
              <span>学分记录管理</span>
            </el-menu-item>
            <el-menu-item index="4-3" @click="setPage('creditrules')" title="查看学校规则信息" style="padding-left: 40px !important;">
              <i class="el-icon-notebook-2"></i>
              <span>学校规则管理</span>
            </el-menu-item>
            
             
          </el-menu-item-group>
        </el-submenu>


        <el-submenu index="2" title="用户管理相关操作">
          <template #title>
            <i class="el-icon-location"></i>
            <span>用户管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="2-1" @click="setPage('users')" title="查看用户信息" style="padding-left: 40px !important;">
              <i class="el-icon-user"></i>
              <span>用户信息</span>
            </el-menu-item>
            <el-menu-item index="2-2" @click="setPage('inform')" title="查看学生信息" style="padding-left: 40px !important;">
              <i class="el-icon-user-solid"></i>
              <span>学生信息</span>
            </el-menu-item>
            <el-menu-item index="2-3" @click="setPage('teacher')" title="查看教师信息" style="padding-left: 40px !important;">
              <i class="el-icon-s-custom"></i>
              <span>教师信息</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="3">
          <template #title>
            <i class="el-icon-s-promotion"></i>
            <span>作品管理</span>
          </template>
            <el-menu-item-group>
              <el-menu-item index="3-1" @click="changWorksStatus(null),setPage('works')" title="查看学生作品" style="padding-left: 40px !important;">
              <i class="el-icon-folder"></i>
              <span>学生作品</span>
            </el-menu-item>
            <el-menu-item index="3-2" @click="changeDialogFormVisible(true), setPage('upload')" title="上传新作品" style="padding-left: 40px !important;">
              <i class="el-icon-upload"></i>
              <span>上传作品</span>
            </el-menu-item>
          
          </el-menu-item-group>
            </el-submenu>
            
      
      </el-menu>
    </div>
  </div>
</template>

<script>
import NavigationBar from '@/js/NavigationBar';
export default {
  ...NavigationBar
}
</script>

<style scoped>

/* 提高选择器优先级，确保样式生效 */
.el-menu .el-submenu .term-submenu {
  padding-left: 50px !important; /* 增加左侧缩进 */
  text-indent: 10px; /* 文字额外缩进，增强层次感 */
}

/* 可选：添加子菜单图标 */
.term-submenu:before {
  margin-right: 8px;
  color: #ccc;
}
.el-menu-item {
  padding: 4px 20px !important; /* 上下内边距从1px缩至4px（可按需调整） */
  line-height: 32px !important; /* 行高降低，控制菜单项高度 */
  margin: 2px 0 !important; /* 项与项之间的外部间距 */
}
/* 一级菜单加深显示 */
.el-submenu__title {
  font-weight: bold;
  font-size: 18px !important;
  background-color: #2a2a2a !important;
  
}

/* 一级菜单图标放大 */
.el-submenu__title i {
  font-size: 20px !important;
}

/* 一级菜单悬停效果 */
.el-submenu__title:hover {
  background-color: #252525 !important;
}

/* 菜单项悬停效果 */
.el-menu-item:hover {
  background-color: #222 !important; /* 修改悬停背景颜色 */
}

/* 子菜单项悬停效果 */
.el-submenu__title:hover {
  background-color: #222 !important; /* 修改悬停背景颜色 */
}

.el-menu-item {
  padding: 1px 20px !important; /* 减小垂直内边距，原先是 0 20px，可根据需要改 */
}

/* 菜单项图标样式 */
.el-menu-item i,
.el-submenu__title i {
  margin-right: 10px;
  font-size: 18px;
}

/* 菜单项文字样式 */
.el-menu-item span,
.el-submenu__title span {
  font-size: 16px;
}

/* 菜单项选中效果 */
.el-menu-item.is-active {
  background-color: #222 !important; /* 修改选中背景颜色 */
}


/* 子菜单项间距 */
.el-submenu__title {
  padding: 0 20px !important;
}

/* 菜单整体样式 */
.el-menu {
  border-right: none;
  height: 100%;
}

/* 菜单项动画效果 */
.el-menu-item,
.el-submenu__title {
  transition: background-color 0.3s ease;
}

/* 子菜单展开动画 */
.el-submenu .el-menu {
  transition: max-height 0.3s ease-in-out;
  overflow: hidden;
}
</style>
